export const PausedMachineStatus = ({ color }: { color?: string }): JSX.Element => {
  color = color || '#828485';

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7252_14877)">
        <path
          d="M13.9615 8.67867C14.1024 7.44154 13.8549 6.19123 13.2534 5.10104C12.6519 4.01086 11.7261 3.13482 10.6044 2.59436C9.48265 2.05391 8.22058 1.87581 6.99311 2.08476C5.76565 2.29371 4.63359 2.87936 3.75388 3.76051C2.87417 4.64167 2.29038 5.77469 2.08345 7.00249C1.87651 8.2303 2.05668 9.49207 2.59898 10.6129C3.14128 11.7337 4.01884 12.6581 5.11001 13.2578C6.20118 13.8575 7.4519 14.1029 8.68879 13.96"
          stroke={color}
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 4.66666V7.99999L9.33333 9.33332"
          stroke={color}
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.3335 11.3333V14.6667"
          stroke={color}
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 11.3333V14.6667"
          stroke={color}
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7252_14877">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PausedMachineStatus;
